import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';

import './css/reset.css'

import Header from './components/Header.js'
import Main from './components/Main.js'
import Visual from './components/Visualization.js'
import Graph from './components/Graph.js'
import DataProduct from './components/Dataproduct.js'
import Notice from './components/Notice.js'
import Footer from './components/Footer.js';
import Admin from './components/Admin/Admin.js';
import AdminLogin from './components/Admin/AdminLogin.js';
import { useEffect, useState } from 'react';
import Map from './components/Map.js';
import DeveloperCenter from './components/DeveloperCenter.js';
import Kare from './components/Kare.js';

import { content } from './components/Content.js';

// ScrollToTop 컴포넌트
function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        // 브라우저의 자동 스크롤 복원 기능 비활성화
        if (window.history.scrollRestoration) {
            window.history.scrollRestoration = 'manual';
        }
        window.scrollTo(0, 0);
    }, [pathname]); // pathname이 바뀔 때마다 (페이지 이동/새로고침 시) 실행

    return null;
}

// 기업출장 페이지는 public/business-travel/의 정적 페이지로 서빙됨.
// 호스팅 rewrite가 /business-travel 요청을 SPA로 넘긴 경우를 위한 폴백.
function BusinessTravelRedirect() {
    useEffect(() => {
        window.location.replace('/business-travel/index.html');
    }, []);
    return null;
}

// App 내부에서 useLocation 사용을 위해 컴포넌트 분리
function AppContent() {
    const location = useLocation();
    const isMapPage = location.pathname === '/map' || location.pathname === '/Map';

    // 사이트 기본 언어(헤더/메인 등)는 ko/en만 사용
    const [siteLang, setSiteLang] = useState('ko');
    // Kare 페이지 전용 언어(ko/en/ar)
    const [kareLang, setKareLang] = useState('ko');

    // 헤더 Language 메뉴에서 호출되는 언어 선택 핸들러
    const handleLanguageChange = (nextLang) => {
      if (nextLang === 'ar') {
        // 아랍어는 Kare 페이지에만 적용
        setKareLang('ar');
        return;
      }
      // ko/en 선택 시 사이트 전체와 Kare를 같은 언어로 동기화
      setSiteLang(nextLang);
      setKareLang(nextLang);
    };

    return (
        <>
            <ScrollToTop />
            <Header
              lang={siteLang}
              kareLang={kareLang}
              onLanguageChange={handleLanguageChange}
              content={content[siteLang]}
            />
            <Routes>
                <Route path="/" element={<Main content={content[siteLang]} />}/>
                <Route path="/visual" element={<Visual content={content[siteLang]} />}/>
                <Route path="/graph" element={<Graph content={content[siteLang]} />}/>
                <Route path="/product" element={<DataProduct content={content[siteLang]} />} />
                <Route path="/notice" element={<Notice content={content[siteLang]} />} />
                <Route path="/map" element={<Map content={content['ko']} />} />
                <Route path="/developer" element={<DeveloperCenter content={content[siteLang]} />} />
                <Route path="/kare" element={<Kare lang={kareLang} />} />
                <Route path="/business-travel/*" element={<BusinessTravelRedirect />} />

            </Routes>
            {!isMapPage && <Footer content={content[siteLang]} />}
        </>
    );
}

// 최종 App 함수
function App() {
    return (
        <ThemeProvider theme={theme}>
            <Router>
                <AppContent />
            </Router>
        </ThemeProvider>
    );
}

export default App;